import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { httpService } from "../../services/httpService";
import { IMetaCampaignHistory } from "../../features/Campaigns/interface/metaAds";
import { useAuth } from "../helper/useAuth";

interface IMetaActivityHistoryResponse {
  success: boolean;
  history: IMetaCampaignHistory[];
  count: number;
}

interface UseMetaAdsActivityHistoryProps {
  params?: Record<string, string | number | boolean>;
  enabled?: boolean;
}

export const useMetaAdsActivityHistory = ({
  params = {},
  enabled = true,
}: UseMetaAdsActivityHistoryProps) => {
  const { selectedIntegration } = useAuth();

  const mergedParams = useMemo(
    () => ({
      ...params,
      tracking_id: selectedIntegration?.value as string,
    }),
    [params, selectedIntegration?.value],
  );

  return useQuery<IMetaActivityHistoryResponse>({
    queryKey: ["metaAdsActivityHistory", mergedParams],
    queryFn: () =>
      httpService.get<IMetaActivityHistoryResponse>(
        "meta-ads/activity-history",
        mergedParams,
      ),
    enabled: !!selectedIntegration?.value && enabled,
    staleTime: 5 * 60 * 1000,
  });
};
